import { stringify } from 'qs';
import request from '@/utils/request';
import { loginCompany, loginOrg } from '@/utils/LoginContext';


export async function query(payload) {
  return request(`/iwms-wms/wms/pickupCombined/queryWithSameStoreMultipleArea`, {
    method: 'POST',
    body: payload,
  });
}


export async function combined(payload) {
  return request(`/iwms-wms/wms/pickupCombined/${payload.pickAreaGroupUuid}/combinedWithSameStoreMultipleArea?dcUuid=${loginOrg().uuid}`, {
    method: 'POST',
    body: payload.uuids,
  });
}

export async function queryPickupBillCombinedInfo(payload) {
  return request(`/iwms-wms/wms/pickupCombined/queryPickupBillCombinedInfo`, {
    method: 'POST',
    body: payload,
  });
}

export async function cancelCombined(payload) {
  return request(`/iwms-wms/wms/pickupCombined/${payload.combinedUuid}/cancelCombined`, {
    method: 'POST'
  });
}

export async function modifyPicker(payload) {
  return request(`/iwms-wms/wms/pickupCombined/${payload.combinedUuid}/modifyPicker?pickerCode=${payload.pickerCode}`, {
    method: 'POST'
  });
}

